import { useIsAiBusy } from '@/features/chats/stores';
import { PopupTextInput } from '@/shared/ui';
import type { PopupTextInputProps } from '@/shared/ui/PopupTextInput/PopupTextInput';

/**
 * A wrapper around PopupTextInput that automatically disables the button and input
 * when the LLM is generating a response. This prevents users from changing
 * agent options mid-generation.
 */
export const ChatPopupTextInput = (props: PopupTextInputProps) => {
  const isAiBusy = useIsAiBusy();

  return <PopupTextInput {...props} disabled={isAiBusy || props.disabled} />;
};
